import { type InjectionKey } from "vue";
import iconSalesforce from "@/static/images/logo-salesforce.svg";
import iconGooglesheets from "@/static/images/logo-googlesheets.svg";
import iconNotion from "@/static/images/logo-notion.svg";
import iconHubspot from "@/static/images/logo-hubspot.svg";
import iconZoho from "@/static/images/logo-zoho.svg";
import { BillingTargetMap } from "@/views/main/account/B/BillingTargetMap";
import { SubscriptionManagementTargetMap } from "@/views/main/account/SubscriptionManagementTargetMap";
import { CardTargetMap } from "@/components/content/newCard/CardTargetMap";
import { ActivityTargetMap } from "@/views/main/activity/ActivityTargetMap";
import { FinderTrackEvents } from "@/views/main/finder/hooks/useTrackEvents";
import { UpdateUnlimitedTargetMap } from "@/components/updateUnlimitedModal/updateUnlimitedTrack";
import { RewardTracks } from "@/views/main/reward/tracks";
// import { FloatingBallTargetMap } from "@/content-script/findFloatingBall/FloatingBallTargetMap";
import { SpecialOfferTracks } from "@/views/main/special-offers/tracks";
import {tracks as AdvanceSearchTracks} from "@/views/main/finder/config"
// 路由白名单
export const allowList = [
  "Home",
  "Login",
  "AdminLogin",
  "Success",
  "SalesforceSuccess",
  "GoogleSheetsSuccess",
  "NotionSuccess",
  "HubspotSuccess",
  "ZohoSuccess",
  "SalesforceFailed",
  "Uninstall",
  "StartPage",
  "GoogleLogin",
  "SpecialOffers",
];

export const LinkedinDomain = "www.linkedin.com";
export const LinkedinUrl = "https://" + LinkedinDomain;
export const LinkedinContactUrl = LinkedinUrl + "/in/williamhgates/";
export const LinkedinDefaultPersonPublicId = "shiragasarch";
export const LinkedinContactUrlPerson =
  LinkedinUrl + "/in/" + LinkedinDefaultPersonPublicId + "/";
export const LinkedinSearchResultsUrl =
  LinkedinUrl +
  "/search/results/people/?keywords=ceo&origin=SWITCH_SEARCH_VERTICAL&sid=QgE";
export const LinkedinCommentsUrl = "https://www.linkedin.com/feed/";
export const CompanyId = "linkedcrm-ai";
// API 页面可免费领取的测试积分数量
export const FREE_API_CREDITS = 100;
export const LinkedinFollowUsUrl = LinkedinUrl + "/company/" + CompanyId + "/";
export const FacebookContactUrl =
  "https://www.facebook.com/share/1BUoBwHhxG/?mibextid=wwXIfr";
export const EmailContactUrl = "julia@leadcontact.ai";

export const OfficialWebsite = import.meta.env.VITE_WEBSITE;

// 根据publicId获取linkedin个人资料页url
export const getLinkedinProfileUrl = (publicId: string) => {
  if (!publicId) return "";
  return LinkedinUrl + "/in/" + publicId + "/";
};

// 客服链接配置：跳转网页端，登录后 identify 用户并自动打开 Chatbase 客服窗口
const ChatbaseBaseUrl = `${import.meta.env.VITE_APP_DOMAIN}/?chatbase=`;
export const ChatbaseUrls = {
  leftcard: ChatbaseBaseUrl + "leftcard",
  contactus: ChatbaseBaseUrl + "contactus",
  sidebar: ChatbaseBaseUrl + "sidebar",
} as const;

// 分享的post id
// export const SharePostId =
//   "leadcontact-ai_looking-to-supercharge-your-lead-generation-activity-7351097456933203970-OtZ4";
// export const SharePostId = "leadcontact-ai_𝗕𝗹𝗮𝗰𝗸-𝗙𝗿𝗶𝗱𝗮𝘆-𝗶𝘀-𝗵𝗲𝗿𝗲-activity-7394657513750679552-1BUs"
export const SharePostId =
  "leadcontact-ai_leadcontact-phone-number-email-finder-for-activity-7405154718341115904-Pkcl";
export const LinkedinSharePostUrl = LinkedinUrl + "/posts/" + SharePostId + "/";

export const YoutubeChannelHandle = "LeadContact-ai";
export const YoutubeFollowUsUrl =
  "https://www.youtube.com/@" + YoutubeChannelHandle;

export const flushClass = "_wl-email-warning-flush-bg-backwards";

export const StatusCode = {
  Success: 200, //  Success
  NotLogin: 4010001, //  Not login or login expired
  MaximumLimit: 4000002, //  Maximum limit
  Provided: 4000003, //  Provided
};

// 登录code
export const LoginCode = {
  Success: 200, // Success
  EmptyOrInvalidEmail: 4000002, // 邮箱字段为空或格式不合法
  TooManyRequests: 4030301, // 验证码发送频率超过阈值
  EmailSendFailed: 5000003, // 邮件发送失败
  EmailAlreadyBound: 4000003, // 邮箱已被绑定
  MissingField: 4000001, // 请求字段缺失
  CodeExpired: 4030001, // 当前验证码过期或失效
  AuthFailed: 4010002, // 登录认证失败
  LoginInvalid: 4010001, // 当前用户登陆状态失效
};

export const ChatActionMap = {
  EmailGenerate: "EmailGenerate",
  PostGenerate: "PostGenerate",
  FindLeads: "FindLeads",
};

export const SyncCodeMap = {
  UNAUTHORIZED: 4010201, //被阻止或未绑定
  NO_PERMISSIONL: 4030201,
  NO_API_PERMISSIONL: 4030202,
  INSUFFICIENT: 4020001, //付费用户积分余额不足
  CREDIT_LIMIT: 4020003, // 超过限额
  PAYMENT_REQUIRED: 402, // 需要付费,接口错误
  ADCLICKLIMIT: 4020005, // 广告一分钟内不能点击
  DAILY_ADS_CREDITS_LIMIT: 4020006, // 激励广告每日领取上限

  IN_PROGRESS: 202, // 后台查询正在进行中，稍后再请求
};

export const PlatformKey = {
  salesforce: "Salesforce",
  googlesheets: "GoogleSheets",
  notion: "Notion",
  hubspot: "Hubspot",
  zoho: "Zoho",
} as const;

export const PlatformMap = {
  Salesforce: "Salesforce",
  GoogleSheets: "Google Sheets",
  Notion: "Notion",
  Hubspot: "Hubspot",
  Zoho: "ZOHO",
} as const;

export const platformIcons = {
  salesforce: iconSalesforce,
  googlesheets: iconGooglesheets,
  notion: iconNotion,
  hubspot: iconHubspot,
  zoho: iconZoho,
} as const;

export const packageUnlimitedQuota = 10000000; // 超过这个数为无限套餐
export const renewalThreshold = 5; // 小于这个数提示续费
export const ReportTargetMap: Record<string, string> = {
  HeaderContinueBtn: "HeaderContinueBtn",

  CardCredits: "CardCredits",
  CardUpgrade: "CardUpgrade",

  EmailFindManualBtn: "EmailFindManualBtn",
  PhoneFindManualBtn: "PhoneFindManualBtn",

  EmailCopyBtn: "EmailCopyBtn",
  EmailSendBtn: "EmailSendBtn",

  PhoneCopyBtn: "PhoneCopyBtn",

  IceBreakerRegenerateBtn: "IceBreakerRegenerateBtn",
  IceBreakerCopyBtn: "IceBreakerCopyBtn",
  IceBreakerSendMessageBtn: "IceBreakerSendMessageBtn",

  ConnectIceBreakerGenerateBtn: "ConnectIceBreakerGenerateBtn",
  ConnectUpgradeBtn: "ConnectUpgradeBtn",

  SummarizeMoreBtn: "SummarizeMoreBtn",

  ReplyUpgradeBtn: "ReplyUpgradeBtn",

  PostGenerateBtn: "PostGenerateBtn",
  PostUpgradeBtn: "PostUpgradeBtn",
  ChatPostGenerateBtn: "ChatPostGenerateBtn",

  FixedSyncBtn: "FixedSyncBtn",
  FixedSummarizeBtn: "FixedSummarizeBtn",
  FixedFindEmailBtn: "FixedFindEmailBtn",
  FixedFindPhoneBtn: "FixedFindPhoneBtn",
  FixedOpenChatBtn: "FixedOpenChatBtn",
  FixedFindKpBtn: "FixedFindKpBtn",
  FixedFindLeadsBtn: "FixedFindLeadsBtn",
  FixedEmailGenerateBtn: "FixedEmailGenerateBtn",
  FixedPostGenerateBtn: "FixedPostGenerateBtn",
  FixedFloatNotifyBtnClick: "FixedFloatNotifyBtnClick", //悬浮球通知按钮点击
  FixedFloatNotifyCloseClick: "FixedFloatNotifyCloseClick", //悬浮球通知关闭按钮点击
  FixedFloatNotifyShow: "FixedFloatNotifyShow", //悬浮球通知展示

  ChatEmailCopyBtn: "ChatEmailCopyBtn",
  ChatEmailSendBtn: "ChatEmailSendBtn",

  ChatPhoneCopyBtn: "ChatPhoneCopyBtn",

  ChatUpgrade: "ChatUpgrade",
  ChatCredits: "ChatCredits",

  ChatUpgradePopover: "ChatUpgradePopover", // 侧边栏弹出付费引导弹窗
  ChatRewardPopover: "ChatRewardPopover", // 侧边栏弹出reward引导弹窗
  ChatUpgradePopover_Upgrade: "ChatUpgradePopover_Upgrade", // 侧边栏点击【Get more credits】按钮
  ChatUpgradePopover_Cancel: "ChatUpgradePopover_Cancel", // 侧边栏点击右上角叉号关闭付费引导弹窗
  ChatUpgradePopover_Reward: "ChatUpgradePopover_Reward", // 侧边栏点击【Get rewards now!】按钮次数窗
  ChatRewardPopover_Cancel: "ChatRewardPopover_Cancel", // 侧边栏点击右上角叉号关闭Reward弹窗次数
  ChatUpgradePopover_Basic: "ChatUpgradePopover_Basic",
  ChatUpgradePopover_Pro: "ChatUpgradePopover_Pro",
  ChatUpgradePopover_Unlimited: "ChatUpgradePopover_Unlimited",

  PhoneFindUnlockBtn: "PhoneFindUnlockBtn",
  PhoneFindUpgradeBtn: "PhoneFindUpgradeBtn",
  PhoneFindRetryBtn: "PhoneFindRetryBtn",

  MainGoToLinkedinBtn: "MainGoToLinkedinBtn",
  MainNewUpgradeBtn: "MainNewUpgradeBtn",

  ClickADBtn: "ClickADBtn",
  ClickAnotherADBtn: "ClickAnotherADBtn",
  ClickChromeReviewBtn: "ClickChromeReviewBtn",
  ClickG2ReviewBtn: "ClickG2ReviewBtn",
  ClickLeaveADBtn: "ClickLeaveADBtn",
  ClickLeaveExitBtn: "ClickLeaveExitBtn",
  OfferWallADPopover: "OfferWallADPopover", //弹出积分墙广告弹窗
  ClickOfferWallADBtn: "ClickOfferWallADBtn", //点击积分墙广告按钮
  // ...Object.entries(PlatformKey).reduce((acc, [key, value]) => {
  //   acc[`SyncTo${value}`] = `SyncTo${value}`;
  //   return acc;
  // }, {} as unknown as Record<string, string>),
  LeasdCredits: "LeasdCredits",

  ChatFindLeadsViewAllBtn: "ChatFindLeadsViewAllBtn",
  ChatFindLeadsBtn: "ChatFindLeadsBtn",

  FindKPBtn: "FindKPBtn",
  FindKPViewAllBtn: "FindKPViewAllBtn",
  CompanyFindKPBtn: "CompanyFindKPBtn",
  CompanyFindKPViewAllBtn: "CompanyFindKPViewAllBtn",
  FindKPViewUserBtn: "FindKPViewUserBtn",
  FindKPUpgradeBtn: "FindKPUpgradeBtn",
  ChatFindKPBtn: "ChatFindKPBtn",
  ChatFindKPViewAllBtn: "ChatFindKPViewAllBtn",

  ClickGuideFollowLCBtn: "ClickGuideFollowLCBtn", //在页面卡片点击关注LC
  ClickFollowLCBtn: "ClickFollowLCBtn", //关注LC
  ClickRewardGuideFollowLCBtn: "ClickRewardGuideFollowLCBtn",

  ClickRepostBtn: "ClickRepostBtn", // 点击转发按钮
  ClickRepostWithThoughtsBtn: "ClickRepostWithThoughtsBtn", // 点击转发并发表看法按钮
  ClickRewardGuideRepostBtn: "ClickRewardGuideRepostBtn", // 点击查看转发引导

  LinkedInUpgradePopover: "LinkedInUpgradePopover", // 在LinkedIn页面弹出付费引导弹窗
  LinkedInUpgradePopover_Upgrade: "LinkedInUpgradePopover_Upgrade", // 在LinkedIn页面的付费引导弹窗点击升级
  LinkedInUpgradePopover_Reward: "LinkedInUpgradePopover_Reward", // 在LinkedIn页面的付费引导弹窗点击去reward页
  LinkedInUpgradePopover_ClickCancel: "LinkedInUpgradePopover_ClickCancel", // 在LinkedIn页面的付费引导弹窗点击右上角叉号次数
  LinkedInUpgradePopover_Cancel: "LinkedInUpgradePopover_Cancel", // 实际关闭在LinkedIn页面的付费引导弹窗

  LinkedInSearchResultExportBtn: "LinkedInSearchResultExportBtn", // 在LinkedIn搜索结果页点击导出按钮
  LinkedInSearchResultExportSuccessBtn: "LinkedInSearchResultExportSuccessBtn", // 在LinkedIn搜索结果页点击导出成功按钮

  Uninstall: "Uninstall", // 卸载

  SwitchYearly: "SwitchYearly", // 切换年付
  SwitchQuarterly: "SwitchQuarterly", // 切换季度付
  SwitchMonthly: "SwitchMonthly", // 切换月付

  BillingYearly_Basic: "BillingYearly_Basic", // 在Billing页点击升级到Basic年付版本
  BillingYearly_Pro: "BillingYearly_Pro", // 在Billing页点击升级到Pro年付版本
  BillingYearly_Unlimited: "BillingYearly_Unlimited", // 在Billing页点击升级到Unlimited年付版本
  BillingYearly_Team: "BillingYearly_Team", // 在Billing页点击升级到Team年付版本
  BillingQuarterly_Basic: "BillingQuarterly_Basic", // 在Billing页点击升级到Basic季度付版本
  BillingQuarterly_Pro: "BillingQuarterly_Pro", // 在Billing页点击升级到Pro季度付版本
  BillingQuarterly_Unlimited: "BillingQuarterly_Unlimited", // 在Billing页点击升级到Unlimited季度付版本
  BillingQuarterly_Team: "BillingQuarterly_Team", // 在Billing页点击升级到Team季度付版本
  BillingMonthly_Basic: "BillingMonthly_Basic", // 在Billing页点击升级到Basic月付版本
  BillingMonthly_Pro: "BillingMonthly_Pro", // 在Billing页点击升级到Pro月付版本
  BillingMonthly_Unlimited: "BillingMonthly_Unlimited", // 在Billing页点击升级到Unlimited月付版本
  BillingMonthly_Team: "BillingMonthly_Team", // 在Billing页点击升级到Team月付版本
  billing_v1_cn_offer_click: "billing_v1_cn_offer_click", // 旧版Billing页-点击中文特惠专区
  AnniversaryOffer_Modal_Show: "AnniversaryOffer_Modal_Show", // 年付活动弹窗-展示
  AnniversaryOffer_Modal_Close_Click: "AnniversaryOffer_Modal_Close_Click", // 年付活动弹窗-点击右上角叉号关闭
  AnniversaryOffer_Modal_Upgrade_Click: "AnniversaryOffer_Modal_Upgrade_Click", // 年付活动弹窗-点击购买按钮
  Plan_AnniversaryBanner_Upgrade_Click: "Plan_AnniversaryBanner_Upgrade_Click", // 年付活动-Plan页顶部Banner-点击购买按钮

  ContactsClickBatchFindEmail: "ContactsClickBatchFindEmail", // 在Contacts页点击批量查询邮箱按钮
  ContactsClickBatchFindPhone: "ContactsClickBatchFindPhone", // 在Contacts页点击批量查询手机号按钮
  ContactsClickSingleFindEmail: "ContactsClickSingleFindEmail", // 在Contacts页点击单个查询邮箱按钮
  ContactsClickSingleFindPhone: "ContactsClickSingleFindPhone", // 在Contacts页点击单个查询手机号按钮
  ContactsClickBatchFindConfirm: "ContactsClickBatchFindConfirm", // 在Contacts页点击批量查询弹窗确认按钮
  ContactsClickNotCreditsToAccount: "ContactsClickNotCreditsToAccount", // 在Contacts页弹窗点击无积分去account页按钮
  ContactsClickNotCreditsToReward: "ContactsClickNotCreditsToReward", // 在Contacts页弹窗点击无积分去reward页文字
  ContactsClickNotAuthorizedToAccount: "ContactsClickNotAuthorizedToAccount", // 在Contacts页弹窗点击同步没绑定去integrations页按钮
  ContactsClickBatchSync: "ContactsClickBatchSync", // 在Contacts页点击批量同步按钮选项
  ContactsClickSyncViewMore: "ContactsClickSyncViewMore", // 在Contacts页点击批量同步按钮的查看更多选项
  ContactsClickSyncConfirm: "ContactsClickSyncConfirm", // 在Contacts页点击批量同步弹窗确认按钮
  ContactsDeleteBtnClick: "ContactsDeleteBtnClick", // Contacts列表-删除按钮点击
  ContactsDeleteCancelClick: "ContactsDeleteCancelClick", // Contacts列表-删除确认弹窗点击取消
  ContactsDeleteConfirmClick: "ContactsDeleteConfirmClick", // Contacts列表-删除确认弹窗点击确认
  Contacts_Export_Button_Click: "Contacts_Export_Button_Click", // Contacts列表-点击导出按钮
  Contacts_Export_Modal_Show: "Contacts_Export_Modal_Show", // Contacts导出弹窗-展示
  Contacts_Export_Modal_Cancel_Click: "Contacts_Export_Modal_Cancel_Click", // Contacts导出弹窗-点击取消按钮
  Contacts_Export_Confirm_Click: "Contacts_Export_Confirm_Click", // Contacts导出弹窗-点击确认按钮
  Contacts_Export_InsufficientCredits_Show:
    "Contacts_Export_InsufficientCredits_Show", // Contacts导出弹窗-积分不足提示展示
  Contacts_Export_Upgrade_Click: "Contacts_Export_Upgrade_Click", // Contacts导出弹窗-积分不足时点击升级按钮
  Contacts_Export_Download_Success: "Contacts_Export_Download_Success", // Contacts导出-文件下载成功
  Contacts_Export_Download_Fail: "Contacts_Export_Download_Fail", // Contacts导出-文件下载失败
  ContactsJumpPersonalWebsite: "ContactsJumpPersonalWebsite", // 在Contacts页点击联系人跳转个人主页
  ContactsJumpCompanyWebsite: "ContactsJumpCompanyWebsite", // 在Contacts页点击公司跳转企业主页
  ContactsClickBatchFindLimit: "ContactsClickBatchFindLimit", // 在Contacts页批量查询达到日上限50条
  ContactsClickBatchFindLimitChecked: "ContactsClickBatchFindLimitChecked", // 在Contacts页批量查询加上勾选达到日上限50条
  ContactsShowPopover_enrich: "ContactsShowPopover_enrich", // 在Contacts页打开弹窗 - 多选确认
  ContactsShowPopover_sync: "ContactsShowPopover_sync", // 在Contacts页打开弹窗 - 同步
  ContactsShowPopover_not_enough_credits:
    "ContactsShowPopover_not_enough_credits", // 在Contacts页打开弹窗 - 没积分
  ContactsShowPopover_not_authorized: "ContactsShowPopover_not_authorized", // 在Contacts页打开弹窗 - 没绑定
  ContactsHidePopover_enrich: "ContactsHidePopover_enrich", // 在Contacts页关闭弹窗 - 多选确认
  ContactsHidePopover_sync: "ContactsHidePopover_sync", // 在Contacts页关闭弹窗 - 同步
  ContactsHidePopover_not_enough_credits:
    "ContactsHidePopover_not_enough_credits", // 在Contacts页关闭弹窗 - 没积分
  ContactsHidePopover_not_authorized: "ContactsHidePopover_not_authorized", // 在Contacts页关闭弹窗 - 没绑定

  // Navbar 相关
  NavbarLogoClick: "NavbarLogoClick", // navbar-logo 的点击
  NavbarCreditsClick: "NavbarCreditsClick", // navbar-余额 的点击
  NavbarUpgradeClick: "NavbarUpgradeClick", // navbar-升级 的点击

  // Company 页面相关
  CompanyDefaultPageShow: "CompanyDefaultPageShow", // Company-缺省页 的展示
  CompanyDefaultPageFindContactBtn: "CompanyDefaultPageFindContactBtn", // Company-缺省页-【Find Contact on LeadContact】按钮 的点击
  CompanyPageShow: "CompanyPageShow", // Company页 的展示
  CompanyPageFindDecisionMakerBtn: "CompanyPageFindDecisionMakerBtn", // Company页-【Find Decision Maker】按钮 的点击
  CompanyPageShowMoreBtn: "CompanyPageShowMoreBtn", // Company页-【show more】按钮 的点击
  CompanyPageShowLessBtn: "CompanyPageShowLessBtn", // Company页-【show less】按钮 的点击
  CompanyPageLinkedinIconBtn: "CompanyPageLinkedinIconBtn", // Company页-【领英图标】按钮 的点击
  CompanyPageClickCloseBtn: "CompanyPageClickCloseBtn", // Company页点击关闭按钮

  // Find Decision Maker 抽屉相关
  FindDecisionMakerDrawerShow: "FindDecisionMakerDrawerShow", // Find Decision Maker-抽屉 的展示
  FindDecisionMakerDrawerUpgradeBtn: "FindDecisionMakerDrawerUpgradeBtn", // Find Decision Maker-抽屉-【升级】按钮 的点击
  FindDecisionMakerDrawerStartBtn: "FindDecisionMakerDrawerStartBtn", // Find Decision Maker-抽屉-【start】按钮 的点击
  FindDecisionMakerDrawerCareerSelect: "FindDecisionMakerDrawerCareerSelect", // Find Decision Maker-抽屉-【职业选择】下拉框 的点击

  // Contact 页面相关
  ContactDefaultPageShow: "ContactDefaultPageShow", // Contact-缺省页 的展示
  ContactDefaultPageBackBtn: "ContactDefaultPageBackBtn", // Contact-缺省页-【back】按钮 的点击
  ContactPageShow: "ContactPageShow", // Contact页 的展示
  ContactPageBackBtn: "ContactPageBackBtn", // Contact页-【back】按钮 的点击
  ContactPageFindMoreDecisionMakerBtn: "ContactPageFindMoreDecisionMakerBtn", // Contact页-【Find More Decision Maker】按钮 的点击
  ContactPageViewAllKeyPersonBtn: "ContactPageViewAllKeyPersonBtn", // Contact页-【View all key person on LeadContact】按钮 的点击
  ContactPageFindEmailBtn: "ContactPageFindEmailBtn", // Contact页-【Find Email】按钮 的点击
  ContactPageFindPhoneBtn: "ContactPageFindPhoneBtn", // Contact页-【Find phone】按钮 的点击
  ContactPageShowMoreBtn: "ContactPageShowMoreBtn", // Contact页-【show more】按钮 的点击 - 暂无
  ContactPageShowLessBtn: "ContactPageShowLessBtn", // Contact页-【show less】按钮 的点击 - 暂无
  ContactPageLinkedinIconBtn: "ContactPageLinkedinIconBtn", // Contact页-【领英图标】按钮 的点击
  ContactPageCopyIconBtn: "ContactPageCopyIconBtn", // Contact页-【复制图标】按钮 的点击
  ContactsGuideInstallChromeExtension: "ContactsGuideInstallChromeExtension", // Contacts页点击出现引导安装Chrome Extension弹窗

  // 谷歌搜索结果页相关
  GoogleSearchResultDetailBtnShow: "GoogleSearchResultDetailBtnShow", // 谷歌的搜索结果页 detail 按钮 的展示 - 暂无
  GoogleSearchResultDetailBtnClick: "GoogleSearchResultDetailBtnClick", // 谷歌的搜索结果页 detail 按钮 的点击

  LinkedInClickChatbaseBtn: "LinkedInClickChatbaseBtn", // 在LinkedIn页面卡片点击chatbase客服按钮
  ChatClickChatbaseBtn: "ChatClickChatbaseBtn", // 在Chat侧边栏点击chatbase客服按钮
  MainClickChatbaseBtn: "MainClickChatbaseBtn", // 在Main后台页点击chatbase联系客服菜单按钮

  GuideClickProfileBtn: "GuideClickProfileBtn", // 在Guide页点击profile选项里try now
  GuideClickSearchBtn: "GuideClickSearchBtn", // 在Guide页点击search选项里try now
  GuideClickFindBtn: "GuideClickFindBtn", // 在Guide页点击find选项里try now
  GuideEnableExtBannerBtnClick: "GuideEnableExtBannerBtnClick", // 在Guide页点击website选项里的Enable extension按钮
  GuideClickCommentsBtn: "GuideClickCommentsBtn", // 在Guide页点击comments选项里try now
  GuideClickProfileBtn_gotoLinkedIn: "GuideClickProfileBtn_gotoLinkedIn", // 在Guide页点击profile选项里Go to LinkedIn and start
  GuideClickSearchBtn_gotoLinkedIn: "GuideClickSearchBtn_gotoLinkedIn", // 在Guide页点击search选项里Go to LinkedIn and start
  GuideClickCommentsBtn_gotoLinkedIn: "GuideClickCommentsBtn_gotoLinkedIn", // 在Guide页点击comments选项里Go to LinkedIn and start
  GuideClickFindBtn_gotoWebsite: "GuideClickFindBtn_gotoWebsite", // 在Guide页点击find选项里Go to Website and start
  EnableExtBannerBtnClick: "EnableExtBannerBtnClick", // 点击页面顶部Enable extension横幅按钮
  RewardEnableExtBtnClick: "RewardEnableExtBtnClick", // 奖励页点击Enable extension按钮
  GuideClickProfileRadio: "GuideClickProfileRadio", // 在Guide页点击profile选项
  GuideClickSearchRadio: "GuideClickSearchRadio", // 在Guide页点击search选项
  GuideClickFindRadio: "GuideClickFindRadio", // 在Guide页点击find选项
  GuideClickCommentsRadio: "GuideClickCommentsRadio", // 在Guide页点击comments选项

  // 低付费地区相关
  LowChatFindPhoneBtn: "LowChatFindPhoneBtn", // 低付费地区在Chat侧边栏点击find phone按钮
  LowContactsFindPhoneBtn: "LowContactsFindPhoneBtn", // 低付费地区在Contacts页点击find phone按钮
  LowCardFindPhoneBtn: "LowCardFindPhoneBtn", // 低付费地区在左侧Card页点击find phone按钮
  LowCareerFindPhoneBtn: "LowCareerFindPhoneBtn", // 低付费地区在领英生态外Career页点击find phone按钮
  LowUpgradeBtn: "LowUpgradeBtn", // 低付费地区通过手机号查询限制弹窗点击升级按钮

  /**巴基斯坦特惠—Plan页展示浮层 */
  LIPKPlanAutoPopupShow: "LIPKPlanAutoPopupShow",
  /**尼日利亚特惠—Plan页展示浮层 */
  LINGPlanAutoPopupShow: "LINGPlanAutoPopupShow",

  MainClickLogo: "MainClickLogo", // 在Main后台页点击logo
  LinkedInClickToLCLogin: "LinkedInClickToLCLogin", // 在领英登录页点击去登录注册LC
  LinkedInClickSendEmail: "LinkedInClickSendEmail", // 在领英登录页点击去打开本地邮箱

  // 领英生态外
  leadContactUpgradePopover: "leadContactUpgradePopover", // 领英生态外弹出付费引导弹窗
  leadContactUpgradePopover_Cancel: "leadContactUpgradePopover_Cancel", // 领英生态外付费引导弹窗点击取消按钮
  leadContactUpgradePopover_Upgrade: "leadContactUpgradePopover_Upgrade", // 领英生态外付费引导弹窗点击升级按钮
  leadContactUpgradePopover_Billing: "leadContactUpgradePopover_Billing", // 领英生态外付费引导弹窗跳转billing页面
  leadContactGoogleSearchResultDetailBtnClose:
    "leadContactGoogleSearchResultDetailBtnClose", // 领英生态外 - Google搜索结果页点击detail按钮关闭icon
  leadContactGoogleSearchResultDetailBtnHide10Minutes:
    "leadContactGoogleSearchResultDetailBtnHide10Minutes", // 领英生态外 - Google搜索结果页点击detail按钮10分钟内关闭
  leadContactGoogleSearchResultDetailBtnNeverShow:
    "leadContactGoogleSearchResultDetailBtnNeverShow", // 领英生态外 - Google搜索结果页点击detail按钮不再展示
  leadContactGoogleSearchResultDetailBtnSettings:
    "leadContactGoogleSearchResultDetailBtnSettings", // 领英生态外 - Google搜索结果页点击detail按钮设置
  leadContactGoogleSearchResultDetailBtnFindEmailAndPhone:
    "leadContactGoogleSearchResultDetailBtnFindEmailAndPhone", // 领英生态外 - Google搜索结果页点击寻找邮箱和手机号按钮
  leadContactGoogleSearchResultDetailBtnFindDM:
    "leadContactGoogleSearchResultDetailBtnFindDM", // 领英生态外 - Google搜索结果页点击寻找DM按钮
  leadContactCareerTipUpgradeBtnShow: "leadContactCareerTipUpgradeBtnShow", // 领英生态外 - 职业选择弹窗【升级】按钮展示

  rewardIndiaPageEarnMoneyNowFirst: "rewardIndiaPageEarnMoneyNowFirst", // RewardIndia页面点击Earn Money Now按钮 - 第一个
  rewardIndiaPageEarnMoneyNowSecond: "rewardIndiaPageEarnMoneyNowSecond", // RewardIndia页面点击Earn Money Now按钮 - 第二个
  rewardIndiaPageLearnMore: "rewardIndiaPageLearnMore", // RewardIndia页面点击Learn More按钮
  cardClickIconJumpRewardIndiaPage: "cardClickIconJumpRewardIndiaPage", // 左侧卡片点击顶部图标跳转印度reward页
  careerClickIconJumpRewardIndiaPage: "careerClickIconJumpRewardIndiaPage", //  领英生态外左侧卡片点击顶部图标跳转印度reward页
  billing_fail_plan_update_payment_click:
    "billing_fail_plan_update_payment_click", //  扣费失败-Plan页点击更新支付方式
  billing_fail_post_sub_update_payment_click:
    "billing_fail_post_sub_update_payment_click", //  扣费失败-订阅后页面点击更新支付方式
  billing_fail_profile_card_warning_click:
    "billing_fail_profile_card_warning_click", //  扣费失败-Web个人信息卡片点击警告提示
  web_sidebar_api_external_click: "web_sidebar_api_external_click", // 后台左侧菜单栏点击“API”跳转官网
  ...BillingTargetMap, // 新版billing页相关
  ...SubscriptionManagementTargetMap, // Subscription Management弹窗相关
  ...CardTargetMap, // 新版卡片页相关
  ...ActivityTargetMap, // 活动相关
  ...FinderTrackEvents, // Finder页相关
  ...UpdateUnlimitedTargetMap, // 升级unlimited弹窗相关
  // ...FloatingBallTargetMap, // 悬浮球相关
  ...SpecialOfferTracks, // 中文特惠相关
  ...RewardTracks, // Reward相关
  ...AdvanceSearchTracks, // 高级搜索相关

  PlanUpgradeModalShow: "PlanUpgradeModalShow", // Plan-升级确认弹窗展示
  PlanUpgradeConfirmClick: "PlanUpgradeConfirmClick", // Plan-升级确认弹窗-点击确认升级按钮
  PlanUpgradeModalHide: "PlanUpgradeModalHide", // Plan-升级确认弹窗关闭
  PlanDowngradeModalShow: "PlanDowngradeModalShow", // Plan-降级确认弹窗展示
  PlanDowngradeConfirmClick: "PlanDowngradeConfirmClick", // Plan-降级确认弹窗-点击确认降级按钮
  PlanDowngradeModalHide: "PlanDowngradeModalHide", // Plan-降级确认弹窗关闭

  OldExtensionMigrationPopupShow: "OldExtensionMigrationPopupShow", // 老插件迁移弹窗展示
  OldExtensionMigrationPopupHide: "OldExtensionMigrationPopupHide", // 老插件迁移弹窗关闭
  OldExtensionMigrationPopupInstall: "OldExtensionMigrationPopupInstall", // 老插件迁移弹窗-点击安装按钮

  ChatGPTAuthAllowClick: "ChatGPTAuthAllowClick", // ChatGPT授权页-点击Allow按钮
  ChatGPTAuthCancelClick: "ChatGPTAuthCancelClick", // ChatGPT授权页-点击Cancel按钮
} as const;
// console.log(ReportTargetMap);

export const WebsiteTrackMap = {
  AppStartPageClickProfileItem: "AppStartPageClickProfileItem", // 在Guide页点击profile选项
  AppStartPageClickSearchResultItem: "AppStartPageClickSearchResultItem", // 在Guide页点击search选项
  AppStartPageClickContinueBtn: "AppStartPageClickContinueBtn", // 在Guide页点击find选项
  AppGuideLoginDialogShow: "AppGuideLoginDialogShow", // 领英未登录时 - 引导登录弹窗展示
  AppGuideLoginDialogHide: "AppGuideLoginDialogHide", // 领英未登录时 - 引导登录弹窗被关闭

  // Login 相关
  AppLoginClickGoogleBtn: "AppLoginClickGoogleBtn", // 在Login页点击Google登录按钮
  AppLoginClickEmailBtn: "AppLoginClickEmailBtn", // 在Login页点击邮箱登录按钮
  AppLoginClickVerificationBtn: "AppLoginClickVerificationBtn", // 在Login页点击验证码登录按钮
  AppLoginClickChangeEmailText: "AppLoginClickChangeEmailText", // 在Login页点击更换邮箱文字
  AppLoginClickResendCodeText: "AppLoginClickResendCodeText", // 在Login页点击重新发送验证码文字
  AppLoginClickPrivacyPolicyText: "AppLoginClickPrivacyPolicyText", // 在Login页点击隐私协议查看
  AppLoginClickContinueBtn: "AppLoginClickContinueBtn", // 在Login页点击继续按钮
  AppLoginAutoLoginTipShow: "AppLoginAutoLoginTipShow", // 在Login页一键登录弹窗展示
  AppLoginAutoLoginTipConfirm: "AppLoginAutoLoginTipConfirm", // 在Login页一键登录弹窗点击确认按钮
  AppLoginAutoLoginSuccess: "AppLoginAutoLoginSuccess", // 在Login页一键登录弹窗登录成功

  // 领英生态外
  AppNotLoginShow: "AppNotLoginShow", // 领英生态外未登录时 - 侧边栏的展示
  AppNotLoginNotLoginClickDetailBtn: "AppNotLoginNotLoginClickDetailBtn", // 领英生态外 - 未登录时搜索结果页点击detail按钮
  AppNotLoginLogInBtn: "AppNotLoginLogInBtn", // 领英生态外未登录时 - Log In 按钮点击
  AppNotLoginGoogleSearchResultDetailBtnClose:
    "AppNotLoginGoogleSearchResultDetailBtnClose", // 领英生态外未登录时 - Google搜索结果页点击detail按钮关闭
  AppNotLoginGoogleSearchResultDetailBtnHide10Minutes:
    "AppNotLoginGoogleSearchResultDetailBtnHide10Minutes", // 领英生态外未登录时 - Google搜索结果页点击detail按钮10分钟内关闭
  AppNotLoginGoogleSearchResultDetailBtnNeverShow:
    "AppNotLoginGoogleSearchResultDetailBtnNeverShow", // 领英生态外未登录时 - Google搜索结果页点击detail按钮不再展示
  AppNotLoginGoogleSearchResultDetailBtnSettings:
    "AppNotLoginGoogleSearchResultDetailBtnSettings", // 领英生态外未登录时 - Google搜索结果页点击detail按钮设置
  AppNotLoginGoogleSearchResultDetailBtnFindEmailAndPhone:
    "AppNotLoginGoogleSearchResultDetailBtnFindEmailAndPhone", // 领英生态外未登录时 - Google搜索结果页点击寻找邮箱和手机号
  AppNotLoginGoogleSearchResultDetailBtnFindDM:
    "AppNotLoginGoogleSearchResultDetailBtnFindDM", // 领英生态外未登录时 - Google搜索结果页点击寻找DM
  AppNotLoginEmptyPageShow: "AppNotLoginEmptyPageShow", // 领英生态外未登录时 - 空页面展示
  AppCompanyPageAutoShow: "AppCompanyPageAutoShow", // 领英生态外侧边栏 - 公司页面自动展示
} as const;

export const RuntimeMessages = {
  Bridge: "Bridge",
  ChatSessionCreated: "ChatSessionCreated", // 侧边栏打开bg收到的消息
  SendToSidePanelChat: "SendToSidePanelChat", // 发送消息
  SalesforceSuccess: "SalesforceSuccess", // Salesforce授权成功
  GoogleSheetsSuccess: "GoogleSheetsSuccess", // GoogleSheets授权成功
  NotionSuccess: "NotionSuccess", // Notion授权成功
  HubspotSuccess: "HubspotSuccess", // Hubspot授权成功
  ZohoSuccess: "ZohoSuccess", // Zoho授权成功
  UpgradeSuccess: "UpgradeSuccess", // 升级成功
  OpenSidePanel: "OpenSidePanel", // 打开侧边栏
  CloseSidePanel: "CloseSidePanel", // 关闭侧边栏
  EnableSidePanel: "EnableSidePanel", // 启用侧边栏
  DisableSidePanel: "DisableSidePanel", // 禁用侧边栏
  // GetCookies: "GetCookies", // 获取cookies
  // GetCookie: "GetCookie", // 获取cookie
  // GetUserProfile: "GetUserProfile", // 获取用户信息
  // GetContact: "GetContact", // 获取联系人信息
  // GetContactStatus: "GetContactStatus", // 获取联系人状态
  // GetSummary: "GetSummary", // 获取用户信息
  // ShortSummarize: "ShortSummarize", // 简短总结
  // ContactSync: "ContactSync", // 联系人同步
  // FindEmail: "FindEmail", // 查找邮箱
  // OauthSalesforce: "OauthSalesforce", // Salesforce授权
  // OauthGoogleSheets: "OauthGoogleSheets", // GoogleSheets授权
  // OauthNotion: "OauthNotion", // Notion授权
  // OauthHubspot: "OauthHubspot", // Hubspot授权
  // OauthZoho: "OauthZoho", // Zoho授权
  OpenApp: "OpenApp", // 打开应用
  CloseTab: "CloseTab", // 关闭标签页
  // GetSettings: "GetSettings", // 获取设置
  // UpdateSettings: "UpdateSettings", // 更新设置
  CancelSwitchContact: "CancelSwitchContact", // 取消切换联系人
  // GetSubscriptionInfo: "GetSubscriptionInfo", // 获取用户信息
  UpdateUserInfo: "UpdateUserInfo", // 更新用户信息
  SendPostToActiveTab: "SendPostToActiveTab", // 发送post到当前标签页
  UpdateUserAuth: "UpdateUserAuth", // 更新用户授权

  ExtensionInstalled: "ExtensionInstalled",

  // OpenNewWindow: "OpenNewWindow", // 打开新窗口
};

export const provideReloadKey: InjectionKey<() => void> = Symbol("reload");
export const provideShowSwitchContactKey: InjectionKey<() => void> =
  Symbol("switchcontact");

// export const StorageKeyMap = {
//   // AutoFindEmail: "AutoFindEmail",
//   // FindEmailPublicIds: "FindEmailPublicIds",
//   // AcceptPrivacyPolicy: "AcceptPrivacyPolicy",
//   // SkipPlatforms: "SkipPlatforms",
//   // AuotSummary: "AuotSummary",
//   // SettingsSummarize: "SettingsSummarize",

//   // LinkedinCardScrollTimes: "LinkedinCardScrollTimes",
//   // ChatUpgradeRetention: "ChatUpgradeRetention",

//   // FindEmailSuccessTimes: "FindEmailSuccessTimes", // 查找邮箱成功次数
//   // FindEmailFailedTimes: "FindEmailFailedTimes", // 查找邮箱失败次数

//   // ResharePostTimes: "ResharePostTimes", // 记录转发post次数

//   // HasVisited: "HasVisited", // 是否是第一次访问插件

//   // FloatBtnPosition: "FloatBtnPosition", // 记录Linkedin浮动按钮位置

//   // SearchResultHeaderHasGuide: "SearchResultHeaderHasGuide", // 搜索结果页头引导
//   // FindType: "FindType", // 记录查找类型
//   // FindSuccessEmail: "FindSuccessEmail", // 记录成功查找邮箱
//   // FindSuccessPhone: "FindSuccessPhone", // 记录成功查找手机
//   // FindSuccessKp: "FindSuccessKp", // 记录成功查找关键人
//   // FindSuccessSync: "FindSuccessSync", // 记录成功同步
//   // HasVisitedLeadContact: "HasVisitedLeadContact", // 记录是否访问过LeadContact
// };

export const AutoFindEmailDefaultTimes = 2; //自动查询

// export const FloatingBallType = "FloatingBallType";
// export enum FloatingBallTypeMap {
//   Nothing = 0, // 全不显示
//   All = 1, // 全显示
//   Includes = 2, // 部分显示
//   Excludes = 3, // 部分不显示
// }
// export const AllowFloatingBallDomains = "AllowFloatingBallDomains";

export const LCWebsite = import.meta.env.VITE_APP_LC_COOKIE_DOMAIN;

// export const DiscountCountdownTime = "DiscountCountdownTime";

// 添加操作记录类型枚举
export enum OperateRecordType {
  SYNC = 1,
  ENRICH_EMAIL = 4,
}
// 添加操作记录状态枚举
export enum OperateRecordStatus {
  PENDING = 1,
  PROCESSING = 2,
  COMPLETED = 10,
  FAILED = 4,
}

// 联系人列表轮询状态
export enum batchStatusMap {
  UNKNOWN = 0,
  RUNNING = 1,
  NOT_ENOUGH = 2,
  LIMITED = 3,
  DONE = 10,
  FAIL = 99,
}
